import Vue from 'vue'
import PictureInput from 'vue-picture-input'

const inferImageMediaTypeFromUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return null
  }

  if (url.startsWith('data:image/')) {
    return url.slice(5, url.indexOf(';'))
  }

  try {
    const parsedUrl = new URL(url, window.location.origin)
    const queryMediaType =
      parsedUrl.searchParams.get('response-content-type') ||
      parsedUrl.searchParams.get('Content-Type')

    if (queryMediaType && queryMediaType.startsWith('image/')) {
      return queryMediaType
    }

    const lowerPath = parsedUrl.pathname.toLowerCase()
    if (lowerPath.endsWith('.jpg') || lowerPath.endsWith('.jpeg')) {
      return 'image/jpeg'
    }
    if (lowerPath.endsWith('.png')) {
      return 'image/png'
    }
    if (lowerPath.endsWith('.pjpeg')) {
      return 'image/pjpeg'
    }
  } catch (error) {
    return null
  }

  return null
}

const normalizeImageMediaType = (mediaType) => {
  if (!mediaType || typeof mediaType !== 'string') {
    return null
  }

  const normalizedMediaType = mediaType.toLowerCase()
  if (
    normalizedMediaType === 'image/pjpeg' ||
    normalizedMediaType === 'image/jpg'
  ) {
    return 'image/jpeg'
  }
  if (normalizedMediaType === 'image/x-png') {
    return 'image/png'
  }

  return normalizedMediaType
}

const PictureInputWithPrefillFix = {
  extends: PictureInput,
  methods: {
    ...PictureInput.methods,
    preloadImage(source, options = {}) {
      const normalizedOptions = { ...options }

      if (
        typeof source === 'string' &&
        !normalizedOptions.mediaType &&
        !normalizedOptions.fileType
      ) {
        const inferredMediaType = inferImageMediaTypeFromUrl(source)
        if (inferredMediaType) {
          normalizedOptions.mediaType =
            normalizeImageMediaType(inferredMediaType) || inferredMediaType
        }
      }

      return PictureInput.methods.preloadImage.call(
        this,
        source,
        normalizedOptions
      )
    },
  },
}

Vue.component('PictureInput', PictureInputWithPrefillFix)
